import Link from "next/link";
import React from "react";
import { MdClose } from "react-icons/md";

export default function ContactAlert({
  showAlert,
  alertMessage,
  alertStatus,
  closeAlert,
  registeredURL,
  registeredSerial,
  children,
}) {
  if (!showAlert) {
    return null;
  }

  return (
    <div className="alert-wrapper">
      <div className="alert-box">
        <div className="alert-head">
          <div>
            {alertStatus || "Error"}
            {registeredSerial && <> | Registered serial: {registeredSerial}</>}
          </div>
          <div onClick={closeAlert}>
            <MdClose />
          </div>
        </div>

        <div className="alert-content">
          {children || (
            <p>
              {alertMessage ||
                "Thank you for reaching out. If you are seeing this, something went wrong. Please contact us via phone."}
            </p>
          )}

          {registeredURL && (
            <Link href={registeredURL} target="_blank">
              View Printer Friendly Version
            </Link>
          )}

          <button type="button" onClick={closeAlert}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export function AlertDetails({ contactEmail, contactPhone, formData }) {
  const hasContactInfo = contactEmail || contactPhone;

  return (
    <>
      <p>Thank you for reaching out!</p>
      <p>
        Your local equipment specialist will typically contact you within 1
        business day to discuss your goals.
      </p>

      <div className="alert-details">
        <p className="alert-details__title">
          Please take a moment to review your submitted information:
        </p>

        <dl className="alert-details__list">
          <div className="alert-details__item">
            <dt>Full Name:</dt>
            <dd>{formData.fname}</dd>
          </div>

          <div className="alert-details__item">
            <dt>Email:</dt>
            <dd>{formData.email}</dd>
          </div>

          <div className="alert-details__item">
            <dt>Phone:</dt>
            <dd>{formData.phone}</dd>
          </div>

          <div className="alert-details__item">
            <dt>Message:</dt>
            <dd>{formData.comment || "N/A"}</dd>
          </div>
        </dl>
      </div>

      {hasContactInfo && (
        <div className="alert-contact">
          <p className="alert-contact__title">
            If you notice any discrepancies, please contact us via phone or
            email:
          </p>

          <ul className="alert-contact__list">
            {contactPhone && (
              <li>
                Phone:
                <a href={`tel:${contactPhone}`}>{contactPhone}</a>
              </li>
            )}

            {contactEmail && (
              <li>
                Email:
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              </li>
            )}
          </ul>
        </div>
      )}
    </>
  );
}
